import React from "react";

type OptionalDetail = {
    text: string;
    isSelected: boolean;
};

export type Line = {
    isHighlighted?: boolean;
    prefix?: string;
    text?: string;
    isBold?: boolean;
    
};

type Props = {
    iconComponent?: React.FC<React.SVGProps<SVGSVGElement> & { title?: string }>;
    heading: string;
    lines?: Line[];
    optionalDetails?: OptionalDetail[];
};

export const DetailsSection: React.FC<Props> = (props) => {
    if (!props.lines?.some((x) => x.text) && !props.optionalDetails?.some((x) => x.isSelected)) {
        return null;
    }

    const IconComponent = props.iconComponent;
    const GetDescriptionLines = () => {
        let descriptionLines: React.ReactNode[] = [];
        if (props.lines) {
            descriptionLines = props.lines.map((line) => {
                if (!line.text) {
                    return <></>;
                }
                if (line.isHighlighted) {
                    return (
                        <span key={line.text} className="highlight">
                            {line.text}
                        </span>
                    );
                } else {
                    return (
                        <span key={line.text} style={{ fontWeight: line.isBold ? "bold" : "normal" }}>
                            {line.prefix}
                            {line.text}
                        </span>
                    );
                }
            });
        } else if (props.optionalDetails) {
            const filtered: OptionalDetail[] = props.optionalDetails.filter((x) => x.isSelected);
            descriptionLines = filtered.map((det) => <span key={det.text}>{det.text}</span>);
        }

        return descriptionLines;
    };

    return (
        <div className="section">
            <div className="row no-gutters section-heading">
                <div className="col-11">
                    <div className="detail-sec-img">{!IconComponent ? "" : <IconComponent />}</div>
                    <span className="detail-sec-heading">{props.heading}</span>
                </div>
            </div>
            <div className="row">
                <div className="col">{GetDescriptionLines()}</div>
            </div>
        </div>
    );
};
